<template>
    <div class="comment-section pt-2 pb-1">
        <div class="d-flex">
            <h2>{{ t("Comments") }}</h2>
            <v-btn
                v-if="!newComment && hasPermissionForAction(PermissionsConstants.WORK_ORDER, PermissionsConstants.VIEW)"
                class="px-2 ml-4"
                color="bal-red"
                dark
                small
                style="min-width: 0;"
                @click.stop="handleNewCommentClick"
            >
                <v-icon>add</v-icon>
            </v-btn>
        </div>

        <v-row v-if="newComment" align="center">
            <v-col style="text-align:right;">
                <v-textarea
                    v-model="comment"
                    :label="t('Comment')"
                    class="text-field-item mt-2 t-spacing"
                    ref="commentArea"
                    dense
                    rows="1"
                    auto-grow
                    hide-details
                    outlined
                    type="text"
                    @keypress.enter="addNewComment"
                />
            </v-col>
            <v-col :cols="2" style="text-align:right;">
                <v-btn class="px-2 ml-2 mt-2" color="bal-red" dark style="min-width: 0;" @click.stop="addNewComment">
                    <v-icon>check</v-icon>
                    {{ t("Send") }}
                </v-btn>
            </v-col>
        </v-row>

        <v-list>
            <v-list-item
                v-for="item in activeWorkOrder.comments"
                :key="item.id"
                style="border-radius: 10px; margin-bottom: 5px; background-color: #F0F0F0"
            >
                <v-list-item-content>
                    <v-list-item-title style="white-space: normal;"> {{ item.comment }}</v-list-item-title>
                    <v-list-item-subtitle>
                        {{ item.first_name ? item.first_name : "" }}({{ item.date ? item.date : "" }})
                    </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                    <v-row no-gutters>
                        <v-btn
                            icon
                            @click="handleDeleteCommentClick(item)"
                            v-if="user.role === 'superadmin' || (item.created_by && item.created_by == user.id)"
                        >
                            <v-icon color="bal-red">fal fa-trash-alt</v-icon>
                        </v-btn>
                    </v-row>
                </v-list-item-action>
            </v-list-item>
            <v-list-item v-if="activeWorkOrder && activeWorkOrder.comments && activeWorkOrder.comments.length <= 0">
                <v-list-item-content>
                    <v-list-item-title>{{ t("No comments found") }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
        </v-list>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import { PermissionsConstants } from "@/permissions";

export default {
    name: "work-order-view-comments",
    data() {
        return {
            newComment: false,
            comment: null
        };
    },
    computed: {
        ...mapState("WorkOrderStore", ["activeWorkOrder"]),
        ...mapState(["user"]),
        ...mapGetters(["hasPermissionForAction"]),
        PermissionsConstants() {
            return PermissionsConstants;
        }
    },
    methods: {
        ...mapActions("WorkOrderStore", ["sendNewComment", "deleteComment"]),
        async addNewComment() {
            let result = await this.sendNewComment(this.comment);
            if (result.success === 1) {
                this.newComment = false;
                this.comment = null;
            }
        },
        async handleDeleteCommentClick(item) {
            if (confirm(this.t("Are you sure you want to delete this comment?"))) {
                await this.deleteComment(item.id);
                this.newComment = false;
                this.comment = null;
            }
        },
        async handleNewCommentClick() {
            this.newComment = true;
            this.$nextTick(() => {
                this.$refs.commentArea.focus();
            });
        }
    }
};
</script>

<style scoped lang="scss">
.comment-section {
    margin-top: 36px;
    border-top: solid 1px black;
}
</style>
